import { useState } from "react"

export const useConfirmBeforeAction = (hasUnsavedChanges: boolean) => {
  const [showDialog, setShowDialog] = useState(false)
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null)

  const checkAndProceed = (action: () => void) => {
    if (hasUnsavedChanges) {
      setPendingAction(() => action)
      setShowDialog(true)
      return
    }
    action()
  }

  const handleConfirm = (onClear?: () => void) => {
    setShowDialog(false)

    if (onClear) {
      onClear()
    }

    if (pendingAction) {
      pendingAction()
      setPendingAction(null)
    }
  }

  const handleCancel = () => {
    setShowDialog(false)
    setPendingAction(null)
  }

  return {
    showDialog,
    checkAndProceed,
    handleConfirm,
    handleCancel,
  }
}
